import React, { Component } from 'react';
import { notification } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { adminUsersResumeAction,adminUsersStatusAction } from '../../../actions/Admin/Users';
import NavMenu from '../sidebar/navBar';
import moment from 'moment-timezone';
import { appConstants } from '../../../_constants';
import SideMenu from '../sidebar/SidebarCustom';
import './../App.css';

class ResumeActivityList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            fieldsList: [],
            code: '',
            sizePerPage: 10,
            fieldSelct: '',
            fieldsCount: "",
            currentPage:1,
            userType:"user"
        }
    }

    componentWillMount() {
        let reqObj = {
            "limit": 10,
            "offset": 0,
        }
        this.props.adminUsersResumeAction(reqObj);
    }

    componentWillReceiveProps(nextProps) {
        console.log("nextProps",nextProps)
       // console.log("nextProps.data.data.length",nextProps.data.data.length)
        if (nextProps  && nextProps.data && nextProps.data.data.length > 0) {
            this.setState({
                fieldsCount: nextProps.data.count,
                fieldsList: nextProps.data.data
            })
        }
    }

    sizePerPageListChange(sizePerPage) {
        alert(`sizePerPage: ${sizePerPage}`);
    } 

    showUser(cell, row, rowIndex){
        console.log("cell",cell)
        return cell && cell.length > 0 ? cell[0].firstName : "-";
        // return(
        //     <button onClick={this.chnageStatus.bind(this,row,"status")}>{row.status}</button>
        // )
    }    
    showProvider(cell, row, rowIndex){
        return cell && cell.length > 0 ? cell[0].firstName : "-" ;
     
    }

    showJobs(cell, row, rowIndex){
        return cell && cell.length > 0 ? "Job" : "Recruiter" ;
    }

    formatDate(iso_date) {
        if (typeof iso_date === 'undefined') {
            return moment().tz().format(appConstants.DATEFORMATNOTTIME);
        }
        return new Date(iso_date).toLocaleDateString("en-US");
    }

    activityDate(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            return (this.formatDate(row.updatedAt))
        } else {
            return <span>-</span>
        }
    }

    onPageChange(page, sizePerPage) {
 
        this.setState({
            currentPage:page
        })

        let reqObj = {
            "limit": 10,
            "offset": page-1,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": "",
            "userType":this.state.userType,
        }
        this.props.adminUsersResumeAction(reqObj);
    }

    render() {
        const {fieldsList, fieldsCount, currentPage} = this.state;
        console.log("fieldsList",fieldsList)
        var options = {
            onPageChange: this.onPageChange.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            paginationPosition: 'bottom', // default is bottom, top and both is all available
            alwaysShowAllBtns: true,
            page: currentPage,
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', 
        };
  
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                    <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="custom-table-wrapper  ">
                        <BootstrapTable data={fieldsList} options={options} remote={true} fetchInfo={{dataTotalSize: this.state.fieldsCount}} pagination> 
                            <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                            <TableHeaderColumn width='300' tdAttr={{'data-attr':'Send By' }} dataField='userDetail' dataFormat={this.showUser.bind(this)}>Send By</TableHeaderColumn>
                            <TableHeaderColumn width='300' tdAttr={{'data-attr':'Recived By' }} dataField='companyDetail' dataFormat={this.showProvider.bind(this)}>Recived By</TableHeaderColumn>
                            <TableHeaderColumn width='300' tdAttr={{'data-attr':'Connect For' }} dataField='jobDetail' dataFormat={this.showJobs.bind(this)}>Connect For</TableHeaderColumn>
                            <TableHeaderColumn  tdAttr={{'data-attr':'Send Date' }} dataField='createdAt' dataFormat={this.activityDate.bind(this)}>Send Date</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div> 
        );
    } 
}

function mapStateToProps(state) {
    console.log("state",state)
    return {
        data: state.AdminUsersList.responseResume,
    };
}

export default withRouter(connect(mapStateToProps, {
    adminUsersResumeAction
})(ResumeActivityList));





// WEBPACK FOOTER //
// ./src/components/Admin/Resume/ResumeActivityList.js